(function () {
  var VARIANT_ID = '58628975362429';
  var CODE_LENGTH = 7;

  var cartRenderTimer = null;
  var saveTimer = null;
  var saveQueue = Promise.resolve();
  var isCartRemoving = false;

  function isVisible(element) {
    return !!(
      element &&
      (element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length)
    );
  }

  function getQuickOrderQty() {
    var qty = 0;

    document.querySelectorAll('.variant-item').forEach(function (element) {
      if (element.textContent.includes('Abilitazione')) {
        var input = element.querySelector('input[type="number"]');

        if (input) {
          qty = parseInt(input.value, 10) || 0;
        }
      }
    });

    return qty;
  }

  function getQuickOrderContainer() {
    var container = null;

    document.querySelectorAll('.variant-item').forEach(function (element) {
      if (element.textContent.includes('Abilitazione')) {
        container = element;
      }
    });

    return container;
  }

  function buildFields(prefix, qty, labelPrefix) {
    var html = '';

    for (var i = 1; i <= qty; i++) {
      html += '<div class="chip-code-row" style="margin:8px 0;">';

      html +=
        '<label style="display:block;margin-bottom:4px;font-weight:600;font-size:14px;">' +
        labelPrefix +
        ' ' +
        i +
        ' * (7 cifre)</label>';

      html +=
        '<input class="chip-code-input ' +
        prefix +
        '-input" ' +
        'data-code-index="' +
        i +
        '" ' +
        'type="text" ' +
        'inputmode="numeric" ' +
        'pattern="[0-9]{7}" ' +
        'maxlength="7" ' +
        'placeholder="Es. 1234567" ' +
        'style="width:100%;min-width:200px;padding:8px;border:1px solid #ccc;border-radius:4px;font-size:14px;box-sizing:border-box;">';

      html +=
        '<p class="chip-code-error" style="display:none;color:red;font-size:13px;margin:4px 0 8px;">' +
        '⚠️ Inserisci un codice chip valido di 7 cifre numeriche.</p>';

      html += '</div>';
    }

    return html;
  }

  function getQuickOrderInputs() {
    var field = document.getElementById('chip-code-field');

    if (!field) {
      return [];
    }

    return Array.prototype.slice.call(
      field.querySelectorAll('.quick-order-input')
    );
  }

  function renderQuickOrderFields() {
    var qty = getQuickOrderQty();
    var container = getQuickOrderContainer();

    if (!container) {
      return;
    }

    var field = document.getElementById('chip-code-field');

    if (qty === 0) {
      if (field) {
        field.style.display = 'none';
      }

      return;
    }

    if (!field) {
      field = document.createElement('div');
      field.id = 'chip-code-field';
      field.style.cssText =
        'margin:8px 0;width:100%;clear:both;grid-column:1 / -1;';

      container.appendChild(field);
    }

    var existingValues = getQuickOrderInputs().map(function (input) {
      return input.value;
    });

    var currentQty =
      parseInt(field.getAttribute('data-qty'), 10) || 0;

    if (currentQty !== qty) {
      field.innerHTML = buildFields(
        'quick-order',
        qty,
        'Codice Chip'
      );

      field.setAttribute('data-qty', qty);

      getQuickOrderInputs().forEach(function (input, index) {
        input.value = existingValues[index] || '';
      });
    }

    field.style.display = 'block';
  }

  function getCartQuantityInputs() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        'input[data-quantity-variant-id="' +
          VARIANT_ID +
          '"]'
      )
    );
  }

  function getDomCartQuantity() {
    var inputs = getCartQuantityInputs();

    if (!inputs.length) {
      return null;
    }

    var input =
      inputs.find(function (element) {
        return isVisible(element);
      }) || inputs[0];

    var quantity = parseInt(input.value, 10);

    return isNaN(quantity) ? null : quantity;
  }

  function getCartRows() {
    var rows = [];
    var seen = [];

    getCartQuantityInputs().forEach(function (input) {
      var row =
        input.closest('tr') ||
        input.closest('.cart-item') ||
        input.closest('[id^="CartItem-"]') ||
        input.closest('[id^="CartDrawer-Item-"]') ||
        input.parentElement;

      if (row && seen.indexOf(row) === -1) {
        seen.push(row);
        rows.push(row);
      }
    });

    return rows;
  }

  function getCartFieldHost(row) {
    return (
      row.querySelector('.cart-item__details') ||
      row.querySelector('.cart-item__quantity') ||
      row
    );
  }

  function getCartFields() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.chip-code-cart-field')
    );
  }

  function getCartInputs() {
    var fields = getCartFields();

    if (!fields.length) {
      return [];
    }

    var visibleField = fields.find(function (field) {
      return isVisible(field);
    });

    if (visibleField) {
      return Array.prototype.slice.call(
        visibleField.querySelectorAll('.cart-input')
      );
    }

    if (window.location.pathname === '/cart') {
      return Array.prototype.slice.call(
        fields[0].querySelectorAll('.cart-input')
      );
    }

    return [];
  }

  function getCartItem() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return (
          cart.items.find(function (item) {
            return String(item.variant_id) === VARIANT_ID;
          }) || null
        );
      });
  }

  function getSavedCodes(item) {
    var codes = [];

    if (!item || !item.properties) {
      return codes;
    }

    for (var i = 1; i <= item.quantity; i++) {
      codes.push(item.properties['Codice Chip ' + i] || '');
    }

    return codes;
  }

  function renderCartFields() {
    /*
     * Evita campi duplicati nella lista ordini rapidi.
     */
    if (document.querySelector('.variant-item')) {
      return Promise.resolve();
    }

    if (!getCartQuantityInputs().length) {
      return Promise.resolve();
    }

    return getCartItem()
      .then(function (item) {
        if (!item) {
          return;
        }

        var domQuantity = getDomCartQuantity();

        var qty =
          domQuantity !== null
            ? domQuantity
            : parseInt(item.quantity, 10) || 0;

        var savedCodes = getSavedCodes(item);

        getCartRows().forEach(function (row) {
          var host = getCartFieldHost(row);
          var field = host.querySelector('.chip-code-cart-field');

          if (!field) {
            field = document.createElement('div');
            field.className = 'chip-code-cart-field';
            field.style.cssText =
              'margin:12px 0;width:100%;clear:both;';

            host.appendChild(field);
          }

          var oldValues = Array.prototype.slice
            .call(field.querySelectorAll('.cart-input'))
            .map(function (input) {
              return input.value;
            });

          var currentQty =
            parseInt(field.getAttribute('data-qty'), 10) || 0;

          if (currentQty !== qty) {
            field.innerHTML = buildFields(
              'cart',
              qty,
              'Codice Chip'
            );

            field.setAttribute('data-qty', qty);

            Array.prototype.slice
              .call(field.querySelectorAll('.cart-input'))
              .forEach(function (input, index) {
                input.value =
                  oldValues[index] ||
                  savedCodes[index] ||
                  '';
              });
          }

          field.style.display = qty > 0 ? 'block' : 'none';
        });
      })
      .catch(function (error) {
        console.error(
          'Errore caricamento campi chip:',
          error
        );
      });
  }

  function getInputErrorElement(input) {
    var row = input.closest('.chip-code-row');

    return row
      ? row.querySelector('.chip-code-error')
      : null;
  }

  function showInputError(input, message) {
    if (!input) {
      return;
    }

    input.style.border = '2px solid red';

    var error = getInputErrorElement(input);

    if (error) {
      error.textContent = message;
      error.style.display = 'block';
    }

    if (isVisible(input)) {
      input.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      input.focus();
    }

    setTimeout(function () {
      input.style.border = '1px solid #ccc';

      if (error) {
        error.style.display = 'none';
      }
    }, 3000);
  }

  function validateInputs(inputs) {
    if (!inputs.length) {
      return false;
    }

    var seen = [];

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var code = input.value.trim();

      /*
       * Il codice deve contenere esattamente 7 cifre.
       */
      if (
        code.length !== 7 ||
        !/^[0-9]{7}$/.test(code)
      ) {
        showInputError(
          input,
          '⚠️ Inserisci un codice chip valido di 7 cifre numeriche.'
        );

        return false;
      }

      if (seen.indexOf(code) !== -1) {
        showInputError(
          input,
          '⚠️ Questo codice chip è già stato inserito.'
        );

        return false;
      }

      seen.push(code);
    }

    return true;
  }

  function isAbilitazioneInCart() {
    return (
      getQuickOrderQty() > 0 ||
      getCartQuantityInputs().length > 0
    );
  }

  function validateAll() {
    if (!isAbilitazioneInCart()) {
      return true;
    }

    var quickQty = getQuickOrderQty();

    if (quickQty > 0) {
      var quickInputs = getQuickOrderInputs();

      if (
        quickInputs.length !== quickQty ||
        !validateInputs(quickInputs)
      ) {
        return false;
      }
    }

    var isCartPage =
      window.location.pathname === "/cart";

    var visibleCartField = getCartFields().some(function (field) {
      return isVisible(field);
    });

    if (isCartPage || visibleCartField) {
      var cartInputs = getCartInputs();

      if (!cartInputs.length) {
        renderCartFields();
        return false;
      }

      if (!validateInputs(cartInputs)) {
        return false;
      }
    }

    return true;
  }
  function getCodesFromInputs(inputs) {
    return inputs.map(function (input) {
      return input.value.trim();
    });
  }

  function buildProperties(existingProperties, codes) {
    var properties = {};

    if (existingProperties) {
      Object.keys(existingProperties).forEach(function (key) {
        if (!/^Codice Chip [0-9]+$/.test(key)) {
          properties[key] = existingProperties[key];
        }
      });
    }

    codes.forEach(function (code, index) {
      if (code) {
        properties['Codice Chip ' + (index + 1)] =
          code;
      }
    });

    return properties;
  }

  function saveCartProperties() {
    if (isCartRemoving) {
      return Promise.resolve();
    }

    var cartInputs = getCartInputs();

    if (!cartInputs.length) {
      return Promise.resolve();
    }

    var codes = getCodesFromInputs(cartInputs);

    return getCartItem()
      .then(function (item) {
        if (!item) {
          return;
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: buildProperties(
              item.properties,
              codes
            )
          })
        });
      })
      .then(function (response) {
        if (response) {
          return response.json();
        }
      })
      .catch(function (error) {
        console.error(
          'Errore salvataggio codici nel carrello:',
          error
        );
      });
  }

  function saveQuickOrderProperties() {
    if (isCartRemoving) {
      return Promise.resolve();
    }

    var quickInputs = getQuickOrderInputs();

    if (!quickInputs.length) {
      return Promise.resolve();
    }

    var codes = getCodesFromInputs(quickInputs);

    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var item = cart.items.find(function (line) {
          return String(line.variant_id) === VARIANT_ID;
        });

        if (!item) {
          return;
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: buildProperties(
              item.properties,
              codes
            )
          })
        });
      })
      .then(function (response) {
        if (response) {
          return response.json();
        }
      })
      .catch(function (error) {
        console.error(
          'Errore salvataggio codici chip:',
          error
        );
      });
  }

  function queueSave(callback) {
    saveQueue = saveQueue
      .then(function () {
        return callback();
      })
      .catch(function (error) {
        console.error(
          'Errore nella coda di salvataggio:',
          error
        );
      });

    return saveQueue;
  }

  function saveActiveProperties() {
    return queueSave(function () {
      return saveQuickOrderProperties();
    }).then(function () {
      return queueSave(function () {
        return saveCartProperties();
      });
    });
  }

  function scheduleCartRender(delay) {
    clearTimeout(cartRenderTimer);

    cartRenderTimer = setTimeout(function () {
      renderCartFields();
    }, delay || 500);
  }

  function scheduleSave() {
    clearTimeout(saveTimer);

    saveTimer = setTimeout(function () {
      if (!isCartRemoving && validateAll()) {
        queueSave(function () {
          return saveCartProperties();
        });
      }
    }, 700);
  }

  function interceptCartRequests() {
    var originalFetch = window.fetch;

    window.fetch = function (url, options) {
      var requestUrl =
        typeof url === 'string'
          ? url
          : url && url.url
            ? url.url
            : '';

      var result = originalFetch.apply(this, arguments);

      if (
        requestUrl.indexOf('/cart/update') !== -1 ||
        requestUrl.indexOf('/cart/change') !== -1 ||
        requestUrl.indexOf('/cart/add') !== -1
      ) {
        result.then(function () {
          setTimeout(function () {
            renderCartFields();

            if (
              !isCartRemoving &&
              getQuickOrderQty() > 0
            ) {
              queueSave(function () {
                return saveQuickOrderProperties();
              });
            }
          }, 800);
        });
      }

      return result;
    };
  }

  document.addEventListener(
    'input',
    function (event) {
      var input = event.target;

      if (
        !input.classList ||
        !input.classList.contains('chip-code-input')
      ) {
        return;
      }

      var cleanValue = input.value
        .replace(/[^0-9]/g, '')
        .slice(0, 7);

      if (input.value !== cleanValue) {
        input.value = cleanValue;
      }

      /*
       * Controllo immediato dei duplicati
       * nella lista ordini rapidi.
       */
      if (
        input.classList.contains('quick-order-input') &&
        cleanValue
      ) {
        var duplicateInput = getQuickOrderInputs().find(function (otherInput) {
          return (
            otherInput !== input &&
            otherInput.value.trim() === cleanValue
          );
        });

        if (duplicateInput) {
          showInputError(
            input,
            '⚠️ Questo codice chip è già stato inserito.'
          );
        }
      }

      if (input.classList.contains('cart-input')) {
        var index = input.getAttribute(
          'data-code-index'
        );

        document
          .querySelectorAll(
            '.chip-code-cart-field .cart-input[data-code-index="' +
              index +
              '"]'
          )
          .forEach(function (mirrorInput) {
            if (mirrorInput !== input) {
              mirrorInput.value = cleanValue;
            }
          });

        scheduleSave();
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;

      if (
        input.classList &&
        input.classList.contains('cart-input')
      ) {
        scheduleSave();
      }

      if (
        input.matches &&
        input.matches(
          'input[data-quantity-variant-id="' +
            VARIANT_ID +
            '"]'
        )
      ) {
        renderCartFields();
        scheduleCartRender(1200);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;

      if (!target || !target.closest) {
        return;
      }

      /*
       * Evita di salvare una riga mentre viene eliminata.
       */
      var removeAction = target.closest(
        'cart-remove-button, quick-order-list-remove-all-button, .cart-remove-button'
      );

      if (removeAction) {
        isCartRemoving = true;

        clearTimeout(saveTimer);
        saveQueue = Promise.resolve();

        setTimeout(function () {
          isCartRemoving = false;
        }, 2000);

        return;
      }

      /*
       * Controllo esplicito del pulsante
       * Visualizza carrello.
       */
      var quickOrderButton = target.closest(
        '.quick-order-list__button'
      );

      if (
        quickOrderButton &&
        getQuickOrderQty() > 0 &&
        !validateInputs(getQuickOrderInputs())
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }

      var quantityButton = target.closest(
        'button[name="plus"], button[name="minus"], .quantity__button'
      );

      if (quantityButton) {
        renderCartFields();
        scheduleCartRender(1200);
      }

      var link = target.closest(
        'a[href*="/cart"], a[href*="/checkout"], [href="/cart"], .cart-link, .quick-order-list__button'
      );

      if (!link) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!validateAll()) {
        return false;
      }

      saveActiveProperties().then(function () {
        window.location.href = link.href;
      });

      return false;
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (!validateAll()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }
    },
    true
  );

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      scheduleCartRender(500);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  interceptCartRequests();

  renderQuickOrderFields();
  renderCartFields();

  setInterval(function () {
    renderQuickOrderFields();
  }, 400);

  setInterval(function () {
    if (getCartQuantityInputs().length) {
      renderCartFields();
    }
  }, 1200);

  setTimeout(function () {
    renderCartFields();
  }, 800);
})();
